import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ExternalLink } from "lucide-react";
import { BreadcrumbJsonLd, ItemListJsonLd } from "../components/JsonLd";

export default function Partners() {
  const [sponsors, setSponsors] = useState([]);
  useEffect(() => { api.get("/sponsors").then(r => setSponsors(r.data)); }, []);
  const grouped = {
    sponsor: sponsors.filter(s => s.tier === "sponsor"),
    partner: sponsors.filter(s => s.tier === "partner"),
  };
  return (
    <div className="max-w-[1400px] mx-auto px-6 py-12">
      <BreadcrumbJsonLd items={[{ name: "Accueil", path: "/" }, { name: "Partenaires", path: "/partners" }]} />
      <ItemListJsonLd
        name="Partenaires Fedevo 2.0"
        description="Sponsors et partenaires officiels de la Fédération Vaudaise du Hip-Hop"
        items={sponsors.map(s => ({
          name: s.name,
          path: s.website,
          image: s.logo_url,
          description: s.tier === "sponsor" ? "Sponsor principal" : "Partenaire",
        }))}
      />
      <div className="mb-10">
        <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--accent)] mb-3">Le réseau Fedevo 2.0</div>
        <h1 className="font-display text-5xl sm:text-6xl">Partenaires & Sponsors</h1>
        <p className="text-[color:var(--text-muted)] mt-3 max-w-2xl">
          Fedevo 2.0 Urban Media existe grâce au soutien d'un collectif de structures passionnées par la street culture.
        </p>
      </div>

      {grouped.sponsor.length > 0 && (
        <section className="mb-12">
          <h2 className="font-display text-3xl mb-5 flex items-center gap-3">
            <span className="h-px flex-1 bg-[color:var(--border)]" />
            Sponsor principal
            <span className="h-px flex-1 bg-[color:var(--border)]" />
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 stagger">
            {grouped.sponsor.map(s => <PartnerCard key={s.id} s={s} big />)}
          </div>
        </section>
      )}

      <section>
        <h2 className="font-display text-3xl mb-5 flex items-center gap-3">
          <span className="h-px flex-1 bg-[color:var(--border)]" />
          Nos partenaires
          <span className="h-px flex-1 bg-[color:var(--border)]" />
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 stagger">
          {grouped.partner.map(s => <PartnerCard key={s.id} s={s} />)}
        </div>
      </section>
    </div>
  );
}

const PartnerCard = ({ s, big }) => {
  const body = (
    <div
      data-testid={`partner-card-${s.id}`}
      className={`card-hover rounded-2xl overflow-hidden border border-[color:var(--border)] bg-[color:var(--bg-elev)] ${big ? 'p-10' : 'p-6'}`}
    >
      <div className={`bg-white rounded-xl flex items-center justify-center ${big ? 'h-52' : 'h-40'}`}>
        <img src={s.logo_url} alt={s.name} className={`${big ? 'max-h-44' : 'max-h-32'} max-w-[80%] object-contain`} />
      </div>
      <div className="mt-4 flex items-center justify-between gap-2">
        <div>
          <div className="font-display text-xl">{s.name}</div>
          <div className="text-xs uppercase tracking-widest text-[color:var(--text-muted)]">
            {s.tier === "sponsor" ? "Sponsor principal" : "Partenaire"}
          </div>
        </div>
        {s.website && <ExternalLink className="w-4 h-4 text-[color:var(--accent)]" />}
      </div>
    </div>
  );
  return s.website ? (
    <a href={s.website} target="_blank" rel="noopener noreferrer">{body}</a>
  ) : body;
};
